import React from 'react';
import { Building2 } from 'lucide-react';

export const defaultRealEstateQuestions = [
  {
    id: 'logo',
    placeholder: 'logo',
    title: 'uploadLogo',
    type: 'avatar',
    image: <Building2 size={60} className='file-icon' />,
    mandatory: false,
  },
  {
    id: 'name',
    type: 'text',
    title: 'name',
    placeholder: 'name',
    mandatory: true,
  },
  {
    id: 'description',
    type: 'text',
    title: 'description',
    placeholder: 'description',
    mandatory: true,
  },
  {
    id: 'address',
    type: 'text',
    title: 'address',
    placeholder: 'address',
    mandatory: false,
  },
  {
    id: 'taxId',
    type: 'text',
    title: 'taxId',
    placeholder: 'taxId',
    mandatory: false,
  },
  {
    id: 'propertyType',
    type: 'select',
    title: 'propertyType',
    placeholder: 'propertyType',
    answers: ['residential', 'commercial', 'other'],
    mandatory: false,
  },
  {
    id: 'ownershipType',
    type: 'select',
    title: 'ownershipType',
    placeholder: 'ownershipType',
    answers: ['leasehold', 'freehold', 'other'],
    mandatory: false,
  },
  {
    id: 'yearBuilt',
    type: 'text',
    title: 'yearBuilt',
    placeholder: 'yearBuilt',
    mandatory: false,
  },
  {
    id: 'size',
    type: 'text',
    title: 'size',
    placeholder: 'size',
    mandatory: false,
  },
  {
    id: 'currentCondition',
    type: 'text',
    title: 'currentCondition',
    placeholder: 'currentCondition',
    mandatory: false,
  },
  {
    id: 'contactName',
    type: 'text',
    title: 'contactName',
    placeholder: 'contactName',
    mandatory: false,
  },
  {
    id: 'contactEmail',
    type: 'email',
    title: 'contactEmail',
    placeholder: 'contactEmail',
    mandatory: false,
  },
];
